module.exports = __webpack_public_path__ + "img/V85.b02f391e.jpg";